<template>
  <div class="page-detail">
    <div class="g-wrap">
      <el-breadcrumb class="g-breadcrumb" separator="/">
        <el-breadcrumb-item :to="`${$subsitePrefix}/innovation`"
          >创新创业</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="`${$subsitePrefix}/innovation/league-list`"
          >创业联盟</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ model.Name }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="g-content" v-loading="loading">
        <div class="head">
          <!-- <el-button class="link" type="primary" round>马上报名</el-button> -->
          <h3 class="title">{{ model.Name }}</h3>
          <div class="attrs">
            <p class="desc">
              <span v-html="model.Description"></span>
            </p>
          </div>
        </div>
        <column-header2 :data="{ name: '联盟章程' }"></column-header2>
        <div class="content" v-html="model.Regulation"></div>
        <column-header2 :data="{ name: '组织机构' }"></column-header2>
        <div class="content" v-html="model.Organization"></div>
        <column-header2 :data="{ name: '联盟成员' }"></column-header2>
        <div class="content" v-html="model.Member"></div>
        <column-header2 :data="{ name: '创业培训' }"></column-header2>
        <div class="content" v-html="model.Training"></div>
        <column-header2 :data="{ name: '理论指导' }"></column-header2>
        <div class="content" v-html="model.TheoryGuidance"></div>
        <column-header2 :data="{ name: '法律解释' }"></column-header2>
        <div class="content" v-html="model.LawInterpretation"></div>
        <div class="attach">
          <column-header2 :data="{ name: '附件信息' }"></column-header2>
          <!-- <div class="attach-title">附件信息</div> -->
          <p v-for="(item, i) in model.FundProject" :key="i">
            <i class="el-icon-link"></i>
            <a
              class="file"
              :href="`/files/${item.FilePath}`"
              :download="item.FileName"
              >{{ item.FileName }}</a
            >
            <a
              class="btn"
              :href="`/files/${item.FilePath}`"
              :download="item.FileName"
              >点击下载</a
            >
          </p>
        </div>
        <div class="relative">
          <div class="prev">
            上一个：
            <router-link
              v-if="prev.Id"
              :to="`${$subsitePrefix}/innovation/league-detail/${prev.Id}`"
              >{{ prev.Name }}</router-link
            >
            <span v-else>没有了</span>
          </div>
          <div class="next">
            下一个：
            <router-link
              v-if="next.Id"
              :to="`${$subsitePrefix}/innovation/league-detail/${next.Id}`"
              >{{ next.Name }}</router-link
            >
            <span v-else>没有了</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCurrentAndAdjacent } from "api/app";
import ColumnHeader from "_c/ColumnHeader2";
import { mapState } from "vuex";

export default {
  data() {
    return {
      loading: false,
      model: {
        title: "",
        time: "",
        source: "",
        content: "",
        id: "1"
      },
      prev: {},
      next: {},
      id: null
    };
  },
  components: {
    [ColumnHeader.name]: ColumnHeader
  },
  created() {
    this.init();
  },
  watch: {
    $route() {
      this.init();
    }
  },
  computed: {
    ...mapState("college", ["collegeData", "currentMajor"])
  },
  methods: {
    loadData() {
      this.loading = true;
      getCurrentAndAdjacent({
        id: this.id,
        name: "League",
        college: this.collegeData.college.Id
      })
        .then(res => {
          this.model = res.current || {};
          this.next = res.next || {};
          this.prev = res.prev || {};
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
        });
    },
    init() {
      this.id = this.$route.params.id;
      this.loadData();
    }
  }
};
</script>

<style lang="scss" scoped>
.page-detail {
  background: #f6f6f9;
  padding-bottom: 40px;
  .title {
    font-size: 32px;
    color: #333333;
    font-weight: 500;
    padding: 8px 0 15px 0;
    line-height: 1.4em;
  }
  .head {
    margin: 0 -72px 0 -72px;
    border-bottom: 1px solid #eee;
    padding: 0 72px;
    overflow: hidden;
    .link {
      float: right;
      margin-top: 40px;
    }
  }
  .attrs {
    font-size: 16px;
    color: #999999;
    line-height: 28px;
    padding-bottom: 24px;
    span {
      padding-right: 50px;
    }
  }
  .content {
    font-size: 18px;
    color: rgba(51, 51, 51, 1);
    line-height: 1.8em;
    ::v-deep p {
      text-indent: 2em;
      padding-bottom: 1em;
    }
  }
  .relative {
    display: flex;
    justify-content: space-between;
    padding: 16px 0;
    border-top: 1px solid #eee;
    margin-top: 40px;
    font-size: 16px;
    .prev {
    }
    .next {
    }
  }
  .g-content {
    padding: 24px 72px 40px 72px;
  }
  .attach {
    &-title {
      font-size: 16px;
      margin: 30px 0 10px 0;
    }
    p {
      height: 22px;
      font-size: 16px;
      color: rgba(51, 51, 51, 1);
      line-height: 22px;
      padding-bottom: 5px;
      i {
        margin-right: 5px;
      }
      a.file {
        margin-right: 30px;
        text-decoration: underline !important;
      }
      a.btn {
        color: $primary-color;
      }
    }
  }
}
</style>
